/**
 * Default XML content for new fiddles
 */
export const DEFAULT_XML = `<?xml version="1.0" encoding="UTF-8"?>
<catalog>
  <book id="1">
    <title>Learning XSLT</title>
    <author>Michael Kay</author>
    <price>39.95</price>
  </book>
  <book id="2">
    <title>XSLT 2.0 and XPath 2.0</title>
    <author>Michael Kay</author>
    <price>49.99</price>
  </book>
</catalog>`

/**
 * Default XSL content for new fiddles
 */
export const DEFAULT_XSL = `<?xml version="1.0" encoding="UTF-8"?>
<xsl:stylesheet version="1.0" xmlns:xsl="http://www.w3.org/1999/XSL/Transform">
  <xsl:output method="html" indent="yes"/>
  <xsl:template match="/">
    <html>
      <head>
        <title>Book Catalog</title>
        <style>body { font-family: Arial, sans-serif; margin: 20px; }
              .book { margin-bottom: 20px; padding: 10px; border: 1px solid #ccc; }
              .title { font-weight: bold; color: #333; }
              .author { color: #666; }
              .price { color: #009900; font-weight: bold; }</style>
      </head>
      <body>
        <h1>Book Catalog</h1>
        <xsl:for-each select="catalog/book">
          <div class="book">
            <div class="title">
              <xsl:value-of select="title"/>
            </div>
            <div class="author">by <xsl:value-of select="author"/></div>
            <div class="price">$<xsl:value-of select="price"/></div>
          </div>
        </xsl:for-each>
      </body>
    </html>
  </xsl:template>
</xsl:stylesheet>`
